import React from 'react';
import styles from './index.module.less';

interface IProps {
    title: string;
    desc: string;
    image: string;
    link: string;
    linkText: string;
}

const CompRecommendProduct: React.FC<IProps> = (props) => {
    return (
        <div className={ `${styles['four-sug-content']} ${styles['four-sug-right']}` }>
            <a
                href={ props.link }
                style={{ textAlign: 'center' }}>
                <img
                    src={ props.image }
                    style={{ width: '160px' }} />
            </a>
            <div className={ styles['product-title'] }>{props.title}</div>
            <div className={ styles['product-desc'] }>{props.desc}</div>
            <div className="text-center">
                <a
                    href={ props.link }
                    className={ styles['pre-order'] }>
                    {props.linkText}
                </a>
            </div>
        </div>
    );
};

export default CompRecommendProduct;
